import useFetchResource from 'hooks/useFetchResource';
import { selectSerializer } from 'libs/serializers';
import api from 'libs/api';

export interface IUseGetUnits<T> {
  buildingId?: number;
  guid?: string;
  initialLoad?: boolean;
  prepareUnit?: T;
  serializer?: (data: { resources: any }) => T[];
}

function useGetUnits<T>({
  guid,
  buildingId,
  prepareUnit,
  initialLoad = false,
  serializer = (data): T[] =>
    selectSerializer<T>(data.resources, { labelKey: 'unit_number', valueKey: 'id' }),
}: IUseGetUnits<T>) {
  const {
    resource: units,
    fetchResource: fetchUnits,
    setResource: setUnits,
  } = useFetchResource<T[]>({
    api: api.account.units.public,
    initialLoad,
    initialParams: { buildingId, guid },
    initialValues: [],
    serializer: (data): T[] => {
      const units: T[] = serializer(data);
      return prepareUnit ? [prepareUnit, ...units] : units;
    },
  });

  return { units, fetchUnits, setUnits };
}

export default useGetUnits;
